<section class="skill-list" id="content">
  <div class="page page-profile">

    <!-- page header -->
    <div class="pageheader">
      <h2>{{lang?.course_sheet}}</h2>
      <div class="page-bar">

        <ul class="page-breadcrumb">
          <li>
            <a [routerLink]="'/'+AppFrontRoutes.DASHBOARD"><i class="fa fa-home"></i>
              {{AppSettings.SITE_TITLE | titlecase}}</a>
          </li>
          <li>
            <a [routerLink]="'/'+AppFrontRoutes.SKILLS_LIST">{{lang?.humanResources }}</a>
          </li>
          <li>
            <a [routerLink]="'/'+AppFrontRoutes.SKILLS_LIST">{{ lang?.skills }}</a>
          </li>
          <li>
            <a> {{ data?.course.course_code }} </a>
          </li>
        </ul>

        <!-- <div class="social-icons" style="margin-bottom: 0px;float: right;">
          <a class="plus-add" [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'">
            <i class="fa fa-plus"></i>
          </a>
        </div> -->
      </div>
    </div>

    <!-- page content -->
    <div class="pagecontent">

      <!-- row -->
      <div class="row">
        <div class="col-md-12 zindexset">
          <div class="panel panel-default">
          <div class="panel-heading">Course Details</div>
          <div class="panel-body ">

            <div class="col-sm-12 nopaddno">

              <!-- Course Code -->
              <div class="col-sm-6 paleft">
                <div class="form-group">
                  <label class="col-sm-12 control-label" for="form-field-1"> {{ lang?.course_code }} </label>
                  <div class="col-sm-12">
                    <input class="form-control" type="text" name="course_code" id="code"
                      value="{{ data?.course.course_code }}" disabled>
                    <span id="message" style="display:none;color:red"></span>
                  </div>
                </div>
              </div>

              <!-- Status of the course -->
              <div class="col-sm-6 non_none">
                <div class="form-group">
                  <label class="col-sm-12 control-label" for="form-field-1"> {{lang?.status_of_the_course}} </label>
                  <div class="col-sm-12">
                    <div class="seperator-10"></div>
                    <div class="seroti">
                      <input type="radio" name="course_status" value="1" checked="checked">
                      <label>OPEN</label>&nbsp;&nbsp;
                    </div>
                    <div class="seroti">
                      <input type="radio" name="course_status" value="2">
                      <label>CLOSED</label>
                    </div>

                    <div class="seroti">
                      <input type="radio" name="course_status" value="3">
                      <label>SUSPENDED</label>
                    </div>

                  </div>
                </div>
              </div>

            </div>


            <div class="col-sm-12 nopaddno">
              <!-- Course Type -->
              <div class="col-sm-6 paleft">
                <div class="form-group">
                  <label class="col-sm-12 control-label" for="form-field-1"> {{ lang?.course_type }} </label>
                  <div class="col-sm-12">
                    <ul class="tags">
                      <li><a class="tag">{{ courseType[data?.course?.course_type]  }}</a></li>
                    </ul>    
                  </div>
                </div>
              </div>

              <!-- Name -->
              <div class="col-sm-6 paright">
                <div class="form-group">
                  <label class="col-sm-12 control-label" for="form-field-1"> {{lang?.name}} </label>
                  <div class="col-sm-12">
                    <input class="form-control" type="text" name="course_name" value="{{ data?.course?.course_name }}"
                      maxlength="150" disabled>
                  </div>
                </div>
              </div>

            </div>

            <div class="col-sm-12 nopaddno">
              <!-- Cost -->
              <div class="col-sm-6 paleft">
                <div class="form-group normal_div">
                  <label class="col-sm-12 control-label" for="form-field-1"> {{ lang?.cost }} </label>
                  <div class="col-sm-12">
                    <input class="form-control" type="text" name="course_cost" value="{{ lang?.course?.course_cost }}"
                      disabled>
                  </div>
                </div>
              </div>
              <!-- Duration Hours -->
              <div class="col-sm-6 paright">
                <div class="form-group">
                  <label class="col-sm-12 control-label" for="form-field-1"> {{ lang?.duration }} </label>
                  <div class="col-sm-12">
                    <input class="form-control" type="text" name="course_hours" value="{{ data?.course?.course_hours }}"
                      disabled>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-sm-12 nopaddno">
              <!-- Topic -->
              <div class="col-sm-6 paleft">
                <div class="form-group">
                  <label class="col-sm-12 control-label" for="form-field-3"> {{ lang?.topic }} </label>
                  <div class="col-sm-12 normal_div">
                    <input class="form-control" type="text" name="course_hours"
                      value="{{ data?.course?.course_treatment}}" disabled>
                  </div>
                </div>
              </div>
              <!-- Available Skills -->
              <div class="col-sm-6 paright">
                <div class="form-group">
                  <label class="col-sm-12 control-label" for="form-field-1"> {{ lang?.available_skills }}
                  </label>
                  <div class="col-sm-12">
                    <!-- If skill exists -->
                    <ul class="tags" *ngIf="data?.available_skills;else empty_skill">
                      <li *ngFor="let skill of data?.available_skills">
                        <a class="tag">{{ skill }} </a>
                      </li>
                    </ul>  
                    
                    <ng-template #empty_skill>
                      <ul>
                        <li class="tags">
                          <a class="tag"> No skills found </a>
                        </li>
                      </ul>
                    </ng-template>
                  </div>
                </div>
              </div>

            </div>

            <div class="col-sm-12 nopaddno">
              <!-- Responsible -->
              <div class="col-sm-6 paleft">
                <div class="form-group">
                  <label class="col-sm-12 control-label" for="form-field-1"> {{ lang?.responsible }} </label>
                  <div class="col-sm-12">
                    <input class="form-control" type="text" name="course_resp" value="{{ data?.course?.course_resp }}"
                      disabled>
                  </div>
                </div>
              </div>

              <!-- Place -->
              <div class="col-sm-6 paright">
                <div class="form-group">
                  <label class="col-sm-12 control-label" for="form-field-1"> {{ lang?.place }} </label>
                  <div class="col-sm-12">
                    <input class="form-control" type="text" name="course_hop" value="{{ data?.course?.course_hop }}"
                      disabled>
                  </div>
                </div>
              </div>
            </div>


            <div class="col-sm-12 nopaddno">
              <!-- Start date -->
              <div class="col-sm-6 paleft">
                <div class="form-group">
                  <label class="col-sm-12 control-label" for="form-field-1"> {{lang?.start_date}} </label>
                  <div class="col-sm-12">
                    <div class="input-group">
                      <input type="text" class="form-control" name="course_start_date" id="date_start"
                        value="{{ data?.course?.course_start_date }}" disabled>
                      <span class="input-group-addon" id="basic-addon2"><i class="fa fa-calendar"></i></span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- End date -->
              <div class="col-sm-6 paright">
                <div class="form-group">
                  <label class="col-sm-12 control-label" for="form-field-1" id="date1"> {{lang?.end_date}} </label>
                  <div class="col-sm-12">
                    <div class="input-group">
                      <input type="text" class="form-control" name="course_end_date" id="date_end"
                        value="{{ data?.course?.course_end_date }}" disabled>
                      <span class="input-group-addon" id="basic-addon2"><i class="fa fa-calendar"></i></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-sm-12 nopaddno">
              <!-- Teaching Materials -->
              <div class="col-sm-6 paleft">
                <div class="form-group ">
                  <label class="col-sm-12 control-label" for="form-field-4"> {{ lang?.teaching_material }} </label>

                  <div class="col-sm-12 nopaddno">
                    <ul *ngIf="data?.course_m.lenght > 0;else empty_course">
                      <li *ngFor="let course of data?.course_m">
                        <a> {{ course }} </a>
                      </li>
                    </ul>
                    <ng-template #empty_course>
                      <ul>
                        <li class="tags">
                          <a class="tag"> No materials found </a>
                        </li>
                      </ul>
                    </ng-template>                    
                  </div>
                </div>
              </div>

              <!-- Teaching -->
              <div class="col-sm-6 paright">

                <div class="form-group">
                  <label class="col-sm-12 control-label" for="form-field-1"> {{ lang?.teacher }} </label>
                  <div class="col-sm-12">

                    <div class="col-sm-12 nopaddno">
                      <ul *ngIf="data?.teacher.lenght > 0;else empty_teacher">
                        <li *ngFor="let teacher of data?.teacher">
                          <a> {{ teacher }} </a>
                        </li>
                      </ul>
                      <ng-template #empty_teacher>
                        <ul>
                          <li class="tags">
                            <a class="tag"> No materials found </a>
                          </li>
                        </ul>
                      </ng-template>                    
                    </div>

                  </div>
                </div>



              </div>
            </div>

          </div>
        </div>
        </div>

        <div class="col-sm-12 zindexset">
          <div class="panel panel-default">
            <div class="panel-heading"> {{lang?.list_of_attendes}} </div>
            <div class="panel-body" style="min-height:300px;">
              <div class="row p-10">

                <div class="col-sm-4" >
                  <ng-multiselect-dropdown [(ngModel)]="addPeople" [placeholder]="lang?.type_of_calibration" [data]="dropdownList" [settings]="dropdownSettings" >
                  </ng-multiselect-dropdown>
                </div>

                <div class="col-sm-2" >
                  <button type="button" class="btn btn-success" (click)="addAttendees()">{{lang?.add_people}}</button>
                </div>
                
              </div>

              <div class="table-responsive">
                <div class="table-responsive">
                  <table class="table table-striped table-hover">
                    <thead>
                      <tr>
                        <th>{{lang?.name}}</th>
                        <th>{{lang?.surname}}</th>
                        <th>{{lang?.task}}</th>
                        <th>{{lang?.dob}}</th>
                        <th>{{lang?.place_of_birth}}</th>
                        <th>{{lang?.fiscal_code}}</th>
                        <th>{{lang?.action}}</th>
                        <th>{{lang?.outcome}}</th>
                        <th>{{lang?.certificate }}</th>
                      </tr>
                    </thead>

                    <tbody id="new_status">
                      <tr *ngFor="let emp of data?.emp">
                        <td>{{ emp?.employee_name }}</td>
                        <td>{{emp?.employee_surname}}</td>
                        <td>{{emp?.employee_task}}</td>
                        <td>{{emp?.employee_dob}}</td>
                        <td>{{emp?.employee_placeOfbirth}}</td>
                        <td>{{emp?.employee_tax_code}}</td>


                        <td>
                          <div class="btn-group dropup">

                            <button type="button" class="btn btn-info dropdown-toggle circle_btn" data-toggle="dropdown"
                              aria-expanded="false"><i class="fa fa-tasks"></i></button>

                            <ul class="dropdown-menu dropdown-menu-right action_btn" role="menu">
                              <li>
                                <a class="blue_action" (click)="removeAttendees(emp)">
                                  <i class="fa fa-trash"></i> 
                                  Erase</a>
                              </li>

                            </ul>
                          </div>

                        </td>
                        <td>

                          <select class="form-control" id="name_change" (change)="update_option(emp?.cirti?.id, $event.target.value);">
                            <option [selected] = "lang?.negative == emp?.cirti?.option" [value]="lang?.negative">{{ lang?.negative }}</option>
                            <option [selected] = "lang?.positive == emp?.cirti?.option" [value]="lang?.positive">{{ lang?.positive }}</option>
                          </select>

                        </td>
                        <td>
                            <!-- File Upload Ref - https://codepen.io/klekotinho77/pen/mdyOKaG -->
                            <!-- Show upload button -->
                            <div class="file-input" *ngIf="(emp?.cirti?.Certificates == '') && (emp?.cirti?.option == 'Positive' || emp?.cirti?.option == 'Positivo')">
                              <form  enctype="multipart/form-data" [formGroup]="createForm" class="form-validation " (ngSubmit)="onSubmit()">
                                <div class="col-md-12">
                                  <!-- (change)="uploadFiles($event)"  -->
                                  <input type="file" formControlName="file_multi" (change)="selectAttachment($event,emp)" id="file-input" class="file-input__input" /> 
                                  <label class="file-input__label" for="file-input">
                                    <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="upload"
                                      class="svg-inline--fa fa-upload fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                      <path fill="currentColor"
                                        d="M296 384h-80c-13.3 0-24-10.7-24-24V192h-87.7c-17.8 0-26.7-21.5-14.1-34.1L242.3 5.7c7.5-7.5 19.8-7.5 27.3 0l152.2 152.2c12.6 12.6 3.7 34.1-14.1 34.1H320v168c0 13.3-10.7 24-24 24zm216-8v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h136v8c0 30.9 25.1 56 56 56h80c30.9 0 56-25.1 56-56v-8h136c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z">
                                      </path>
                                    </svg>
                                    <span>Upload file</span></label>
                                </div>

                              </form>
                            </div>

                            <!-- Show certificate file -->
                            <div *ngIf="(emp?.cirti?.Certificates && emp?.cirti?.Certificates != '') && (emp?.cirti?.option == 'Positive' || emp?.cirti?.option == 'Positivo')  ">
                              <a > {{emp?.cirti?.Certificates}} </a>
                              <a class="btn btn-light-grey btn-sm " href="javascript:void(0);" style="color: red;" (click)="remove_certi(emp?.employeeId)">
                                <span class="glyphicon glyphicon-trash"></span>
                              </a>
                            </div>

                        </td>
                      </tr>

                    </tbody>
                  </table>
                </div>

              </div>

            </div>
          </div>

        </div>
      </div>

    </div>
  </div>
</section>